var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var SnapSet = require("./../../snap/snapSet.js");
var AbstractPosAngleScaleInteractionModel = require("./../../../abstract/abstractPosAngleScaleInteractionModel.js");


var LogoInteractionModel = function(logoData, editorModel) {
    AbstractPosAngleScaleInteractionModel.call(this, logoData, editorModel);

    // this.handle = this.value("handle", null, true, true);
    // this.handle(new LogoHandleModel(logoData));
};
lib_core.inherit(LogoInteractionModel, AbstractPosAngleScaleInteractionModel);
LogoInteractionModel.$class = "LogoInteractionModel";

module.exports = LogoInteractionModel;

LogoInteractionModel.prototype.initialize = function () {
    var self = this;

    AbstractPosAngleScaleInteractionModel.prototype.initialize.call(this);

    this.showData = this.shadow("showData", false,
        function () {
            return self.data.data();
        },
        function (value) {
            return self.data.data(value);
        },
        [[this.data.data, this.data.data.onChange]]
    );
};

LogoInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = AbstractPosAngleScaleInteractionModel.prototype.getInspectorElements.call(this);

    inspectorElements.input_elements.push(
        {
            label      : 'Data',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showData
        }
    );

    inspectorElements.help_elements = {
        'name': 'Logo'
    };

    return inspectorElements;
};
